window.NativeCart = window.NativeCart || {};

window.NativeCart.add = function (items) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const body = { items: Array.isArray(items) ? items : [items] };

  if (cart) {
    body.sections = cart.getSectionsToRender().map((section) => section.id);
    body.sections_url = window.location.pathname;
  }

  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        const error = new Error(response.description || response.message || 'Error adding to cart');
        error.response = response;
        throw error;
      }

      if (cart) {
        cart.renderContents(response);
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'native-cart-add', cartData: response });
      }

      return response;
    });
};

window.NativeCart.applyDiscount = function (code) {
  return fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(code), {
    credentials: 'same-origin',
  });
};
